import {Injectable} from '@angular/core';
import {SwitchpayApi} from '../../api/switchpay/switchpay.api.class';
import {Observable} from 'rxjs';
import {RedirectRequest} from '../../interfaces/switchpay/RedirectRequest';
import {SwitchpayPaymentUpdateRequest} from '../../interfaces/switchpay/SwitchpayPaymentUpdateRequest';

@Injectable({
  providedIn: 'root'
})
export class SwitchpayService {


  constructor(private switchpayApi: SwitchpayApi) {
  }

  initializeSwitchpay(sessionToken: string) {
    return this.switchpayApi.initializeSwitchpay(sessionToken);
  }

  public redirectSwitchpay(sessionToken: string, redirectRequest: RedirectRequest): Observable<any> {
    return this.switchpayApi.redirectSwitchpay(sessionToken, redirectRequest);
  }

  public validateSwitchpay(sessionToken: string, switchpayPaymentUpdateRequest: SwitchpayPaymentUpdateRequest): Observable<any> {
    return this.switchpayApi.validateSwitchpay(sessionToken, switchpayPaymentUpdateRequest);
  }
}
